/*
 * Copyright (c) 2020. American Express Company
 */

import { LocalDateTime, LocalDate } from '@js-joda/core';

export enum DebtModelType {
    Mortgage = 'mortgage',
    Student = 'student',
    Auto = 'auto',
    Personal = 'personal',
    CreditCard = 'credit card',
    Other = 'other'
}

export enum DebtModelSubtype {
    HomeEquityLoan = 'homeEquityLoan'
}

export class DebtModel {
    id?: number;
    name: string;
    type: DebtModelType;
    subtype?: DebtModelSubtype;
    amount: number;
    interest: number;
    startDate!: LocalDate;
    endDate!: LocalDate;
    accountId?: number;
    duration?: number;
    interestSuppliedBySync?: boolean; // true if external API gave us the interest rate
    minimumPaymentPercent?: number; // percent of amount that's minimum payment, if given by external API
    annualInterestPaid?: number; // interest paid in previous year
    lastPayment?: number; // amount of last payment
    userSpecifiedMonthlyPayment?: number; // useful in NSZ onboarding
    created?: LocalDateTime;
    updated?: LocalDateTime;

    public static debtTypes: Array<[string, DebtModelType]> = [
        ['Mortgage', DebtModelType.Mortgage],
        ['Student Loan', DebtModelType.Student],
        ['Auto Loan', DebtModelType.Auto],
        ['Personal Loan', DebtModelType.Personal],
        ['Credit Card', DebtModelType.CreditCard],
        ['Other', DebtModelType.Other]
    ];

    public static debtTypeKeys: DebtModelType[] = DebtModel.debtTypes.map((debtType: [string, DebtModelType]) => {
        return debtType[1];
    });
}
